"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setFolderMruConfigurationService_1 = require("../services/setFolderMruConfigurationService");
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
var MAX_MRU_FOLDER_COUNT = 10;
/**
 * Action to add a folderId to Mru list and save it to server
 * @param folderId - folderIs to add to mru list
 */
exports.default = legacy_1.action('addFolderIdToMoveToMruList')(function addFolderIdToMoveToMruList(folderId) {
    updateFolderMruList(folderId);
    var store = store_1.getStore();
    if (store.isInitialized) {
        setFolderMruConfigurationService_1.default(store.mruFolders);
    }
});
function updateFolderMruList(folderId) {
    var store = store_1.getStore();
    var index = store.mruFolders.indexOf(folderId);
    if (index >= 0) {
        // Move the folderId to front if it already exists in the list
        store.mruFolders.splice(index, 1);
        store.mruFolders.unshift(folderId);
    }
    else {
        // Add folderId to front of the list and trim the list
        store.mruFolders.unshift(folderId);
        store.mruFolders.splice(MAX_MRU_FOLDER_COUNT);
    }
}
//# sourceMappingURL=addFolderIdToMoveToMruList.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-move-mru/lib/actions/addFolderIdToMoveToMruList.js
// module id = 4733
// module chunks = 51